import { FC, useMemo } from "react";
import SideImageLayout from "@components/SideImageLayout/SideImageLayout";
import InviteForm from "@components/InviteForm";
import { useSearchParams } from "react-router-dom";

const Invite: FC = () => {
  const [searchParams] = useSearchParams();
  const code = useMemo(() => searchParams.get("code"), [searchParams]);

  return (
    <SideImageLayout>
      <InviteForm code={code} />
    </SideImageLayout>
  );
};

export default Invite;
